import {
  Box,
  Divider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import type { LogRecord } from '@repo/api-gw-sdk';

import { dayjs, DATE_TIME_FORMAT } from '@/utils/dayjs';

import {
  logSpaceSummaryFields,
  generateColumns,
} from './logSpaceResultsTableColumns';

import { PanelWrapper } from '../../panels/panelWrapper';
import { useFields, type FormattedField } from '../../table/hooks';

export const LogSpaceRecordCard = ({
  entry,
  onClose,
}: {
  entry: LogRecord;
  onClose: () => void;
}) => {
  return (
    <PanelWrapper
      header={{
        title: 'Log details',
        onClose,
        hideBorder: true,
      }}
    >
      <Box className='pb-[40px]' overflow='auto'>
        <LogClubFields entry={entry} />
      </Box>
    </PanelWrapper>
  );
};

const LogClubFields = ({ entry }: { entry: LogRecord }) => {
  const logSpaceDetailsFields = generateColumns([entry]);
  const summaryFields = useFields(logSpaceSummaryFields, entry);
  const detailsFields = useFields(logSpaceDetailsFields, entry);

  return (
    <Stack className='pt-[40px]' gap='24px'>
      <Typography
        className='px-[40px]'
        variant='h2'
        data-testid='side-panel-resource-name'
      >
        {dayjs.utc(entry.timestamp).format(DATE_TIME_FORMAT)}
      </Typography>
      <Stack gap='24px' divider={<Divider />}>
        <FieldsTable fields={summaryFields} />
        <FieldsTable fields={detailsFields} />
      </Stack>
    </Stack>
  );
};

const FieldsTable = ({ fields }: { fields: FormattedField[] }) => {
  return (
    <TableContainer sx={{ paddingX: '24px' }}>
      <Table>
        <TableBody>
          {fields.map((field) => (
            <TableRow key={field.id} sx={{ verticalAlign: 'top' }}>
              <TableCell
                sx={{
                  width: '1%',
                  minWidth: '200px',
                  whiteSpace: 'nowrap',
                  borderBottom: 'none',
                  paddingY: '8px',
                }}
              >
                {field.title}
              </TableCell>
              <TableCell
                sx={{ flexGrow: 1, borderBottom: 'none', paddingY: '8px' }}
              >
                {field.Component}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
